export default "__VITE_ASSET__C4_gt8Y2__"